function useStreamContainer() {
  const isSameStream = (stream1, stream2) => getStreamKey(stream1) === getStreamKey(stream2);
  const getStreamKey = (stream) => `${stream == null ? void 0 : stream.userId}_${stream == null ? void 0 : stream.streamType}`;
  return {
    isSameStream,
    getStreamKey
  };
}
export {
  useStreamContainer as default
};
